import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userSlice';
import impersonationReducer from './impersonationSlice';
import courseReducer from './courseSlice';
import navigationReducer from './navigationSlice';
import { isProduction } from '../components/common/helpers';

const rootReducer = combineReducers({
  user: userReducer,
  impersonation: impersonationReducer,
  course: courseReducer,
  navigation: navigationReducer,
});

const persistConfig = {
  key: 'mss:root',
  storage,
  /**
   * Important!
   * Justify the reason to persist a reducer state
   */
  whitelist: [
    // to persist logged in user on reload
    'user',

    // to persist impersonation on reload
    'impersonation',

    // to persist the selected course on reload
    'course',

    // to persist sidenav collapse state on reload
    'navigation',
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // redux-persist dispatches actions carrying non-serializable function values
  // (e.g. PERSIST's register/rehydrate) — ignore them per RTK's own guidance:
  // https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: !isProduction() && { trace: true },
});

export const persistor = persistStore(store);
